import { render, staticRenderFns } from "./ServicesHistory.vue?vue&type=template&id=2952353c&scoped=true&"
import script from "./ServicesHistory.vue?vue&type=script&lang=js&"
export * from "./ServicesHistory.vue?vue&type=script&lang=js&"
import style0 from "./ServicesHistory.vue?vue&type=style&index=0&id=2952353c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952353c",
  null
  
)

export default component.exports